module.exports = __webpack_public_path__ + "img/he-top.fc49de14.png";